import { defineRecipe } from '@chakra-ui/react'

export const statusBadgeRecipe = defineRecipe({
  className: 'ui-status-badge',
  base: {
    alignItems: 'center',
    borderRadius: 'md',
    display: 'inline-flex',
    fontSize: '[12px]',
    fontWeight: '[700]',
    justifyContent: 'center',
    letterSpacing: '[0.05em]',
    lineHeight: '[1]',
    minHeight: '[28px]',
    paddingLeft: '[20px]',
    paddingRight: '[20px]',
    paddingTop: '[7px]',
    paddingBottom: '[7px]',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  variants: {
    tone: {
      neutral: {
        bg: 'var(--theme-accent-background)',
        color: 'var(--theme-text-color)',
      },
      success: {
        bg: 'var(--success-bg-translucent)',
        color: 'var(--success-fg-badge)',
      },
      warning: {
        bg: 'var(--warning-bg-translucent)',
        color: 'var(--warning-fg-badge)',
      },
      danger: {
        bg: 'var(--error-bg-translucent)',
        color: 'var(--error-fg)',
      },
      info: {
        bg: 'var(--info-bg-translucent)',
        color: 'var(--info-fg)',
      },
    },
  },
  defaultVariants: {
    tone: 'neutral',
  },
})
